import { Box, List, Paper } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { T } from "react-translator-component";
import AdminPageFrame from "../components/AdminPageFrame";
import LoadingModal from "../../components/LoadingModal";
import { useAppDispatch } from "../../redux/store";
import { setErrorObj } from "../redux/errorReducer";
import dayjs from "../../util/dayjs";
import { styles as baseStyles } from "../components/statistics/styles";
import Summary from "../components/statistics/Summary";
import UsersUtilization from "../components/statistics/UsersUtilization";
import Section from "../components/Section";

export default function Statistics() {
  const today = useMemo(() => dayjs(), []);

  const dispatch = useAppDispatch();
  const [loader, setLoader] = useState<boolean>(false);
  const [initializedItems, setInitializedItems] = useState<string[]>([])

  useEffect(() => {
    const isInitialized = ['summary', 'users-utilization'].every((key: string) =>
      initializedItems.some((item: string) => item === key)
    )
    setLoader(!isInitialized);
  }, [initializedItems])

  const handleError = (error: any) => {
    dispatch(setErrorObj(error))
  }

  return (
    <AdminPageFrame>
      <LoadingModal visible={loader} />
      <Box component={Paper} sx={baseStyles.baseContainer}>
        <Summary
          baseDate={today}
          initialized={() => setInitializedItems((prev) => [...prev, 'summary'])}
          handleError={handleError}
        />

        <Section title={T('mng_statistics_users')}>
          <List component="nav" sx={styles.users}>
            <UsersUtilization
              baseDate={today}
              initialized={() => setInitializedItems((prev) => [...prev, 'users-utilization'])}
              handleError={handleError}
            />
          </List>
        </Section>
      </Box>
    </AdminPageFrame>
  );
}

const styles = {
  users: {
    "& .MuiListItem-root": {
      display: "block"
    },
    "& .MuiCollapse-root": {
      width: "100%",
      justifyContent: "center",
      textAlign: "center"
    }
  }
}
